import { render, staticRenderFns } from "./FoldMask.vue?vue&type=template&id=478cfd18&scoped=true&"
import script from "./FoldMask.vue?vue&type=script&lang=js&"
export * from "./FoldMask.vue?vue&type=script&lang=js&"
import style0 from "./FoldMask.vue?vue&type=style&index=0&id=478cfd18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478cfd18",
  null
  
)

export default component.exports